import {
   urlAbm,
   urlEmpresa,
   urlFiles,
   urlFlujoAgro,
   urlMailBackend,
} from '@/helpers';
import { httpInstance } from '@/clients/http.request';
import { urlMail } from '@/helpers';
import { getLoteId } from '@/helpers/loteAdicionales';
import { mensajeConfirmacion } from '@/composables/mensajesSwal';
import { sendFallbackEmail } from '@/composables/useFallbackEmail';
export const saveFormData = async ({ commit }, data) => {
   const id = Date.now();
   data.id = id;
   commit('addFormData', data);
};

export const updatedData = async ({ commit }, data) => {
   commit('updateFormData', data);
};

export const deleteData = async ({ commit }, data) => {
   commit('deleteFormData', data);
};

export const getPlanes = async ({ rootState, commit, dispatch }, body) => {
   const id_poliza = rootState.poliza.poliza.id_poliza;
   const id_lotes = rootState.poliza.lotes
      .map((e) => getLoteId(e))
      .filter((id) => id != null);

   try {
      const { data } = await httpInstance.post(`${urlFlujoAgro}/planes`, {
         id_poliza,
         id_lotes,
      });
      commit('setTotalHa', data.sumatoriaHectareas);
      dispatch('getDescuentos', data.sumatoriaHectareas);
      return data.planes;
   } catch (error) {
      throw error;
   }
};

export const getDescuentos = async (
   { commit, rootState },
   sumatoriaHectareas,
) => {
   try {
      const id_grupo = rootState.auth.usuario.id_grupo;
      const { data } = await httpInstance.get(`${urlFlujoAgro}/descuentos`, {
         sumatoriaHectareas,
         id_grupo,
      });
      commit('setDescuentos', data);
   } catch (error) {
      throw error;
   }
};

export const getDepartamento = async ({ commit }, id_departamento) => {
   try {
      const { data } = await httpInstance.get(
         `${urlFlujoAgro}/coords/${id_departamento}`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const sendMailPlanes = async ({ commit }, data) => {
   try {
      const response = await httpInstance.post(
         `${urlMail}/sendMailPlanes`,
         data,
         true,
      );
      mensajeConfirmacion(
         'Envio de email exitoso',
         `Se envio el correo a <b>${data.get('to')}</b>`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const notifyAgroEDC = async ({ state, rootState, commit, dispatch }) => {
   try {
      const id_poliza = rootState?.poliza?.poliza?.id_poliza;

      if (!id_poliza) {
         throw new Error('id_poliza es requerido');
      }

      await httpInstance.post(`${urlMailBackend}/notifyAgroEDC`, {
         id_poliza,
      });

      return;
   } catch (error) {
      try {
         await sendFallbackEmail({
            id_poliza: rootState?.poliza?.poliza?.id_poliza,
         });
      } catch (fallbackError) {
         console.error('Error al enviar fallback email:', fallbackError);
      }
      throw error;
   }
};

export const planSiembra = async ({ commit }, data) => {
   const formData = new FormData();
   data.files.map((file) => {
      formData.append('files', file);
   });
   formData.append('id_cliente', data.id_cliente);
   formData.append('id_poliza', data.id_poliza);
   formData.append('id_empresa', data.id_empresa);
   formData.append('helada', data.helada);
   formData.append('viento', data.viento);
   formData.append('planchado', data.planchado);
   formData.append('incendio_rastrojo', data.incendio_rastrojo);

   try {
      const response = await httpInstance.post(
         `${urlFiles}/planSiembra`,
         formData,
         true,
      );
      return response.data;
   } catch (error) {
      error.message =
         'No pudimos procesar el archivo. Verificá que sea un archivo CSV válido y volvé a intentarlo.';
      throw error;
   }
};

export const getExcelPlanSiembra = async (_, isBsa) => {
   try {
      const response = await httpInstance.get(
         `${urlFlujoAgro}/excel-planSiembra`,
         {
            bsa: isBsa,
         },
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getFormasPago = async ({ rootState, commit }) => {
   try {
      const body = {
         id_empresa: rootState.auth.usuario.id_empresa,
         id_compania: rootState.poliza.poliza.id_compania,
      };
      const { data } = await httpInstance.get(`${urlFlujoAgro}/pago`, body);
      commit('setFormasPago', data);
      return data;
   } catch (error) {
      throw error;
   }
};

export const notifyAgroClient = async ({ rootState }) => {
   try {
      const id_poliza = rootState?.poliza?.poliza?.id_poliza;

      if (!id_poliza) {
         throw new Error('ID de póliza no disponible.');
      }

      await httpInstance.post(`${urlMailBackend}/notifyAgroClient`, {
         id_poliza,
      });
      return { success: true };
   } catch (error) {
      try {
         await sendFallbackEmail({
            id_poliza: rootState?.poliza?.poliza?.id_poliza,
         });
      } catch (fallbackError) {
         console.error('Error al enviar fallback email:', fallbackError);
      }
      throw error;
   }
};

export const iconAgro = async () => {
   try {
      const iconAgro = await httpInstance.getFileEmail(
         `${urlFlujoAgro}/iconAgro`,
         {},
         {
            responseType: 'arraybuffer',
         },
      );
      return iconAgro.data;
   } catch (error) {
      throw error;
   }
};

export const guardarTasas = async ({ rootState }, id_poliza) => {
   try {
      const response = await httpInstance.post(`${urlFlujoAgro}/guardarTasas`, {
         id_poliza,
      });
      return;
   } catch (error) {
      throw error;
   }
};

export const savePDFToStorage = async ({ rootState }, data) => {
   try {
      const formData = new FormData();
      formData.append('files', data.file);
      formData.append('id_empresa', data.id_empresa);
      formData.append('id_poliza', data.id_poliza);
      formData.append('id_seccion', data.id_seccion);
      formData.append('id_cliente', data.id_cliente);
      formData.append('esCotizacion', true);

      const response = await httpInstance.post(
         `${urlFiles}/loadPolizaGranizo`,
         formData,
         true,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getProvinciasCotizables = async ({ commit }) => {
   try {
      const { data } = await httpInstance.get(
         `${urlFlujoAgro}/provincias-cotizables`,
      );
      commit('setProvinciasCotizables', data);
      commit('setDepartamentosCotizablesReset');
      return data;
   } catch (error) {
      throw error;
   }
};

export const getDepartamentosCotizables = async (
   { commit, state },
   id_provincia,
) => {
   if (state.departamentosCotizables?.[id_provincia]) {
      return state.departamentosCotizables[id_provincia];
   }
   try {
      const { data } = await httpInstance.get(
         `${urlFlujoAgro}/departamentos-cotizables/${id_provincia}`,
      );
      commit('setDepartamentosCotizables', {
         id_provincia,
         departamentos: data,
      });
      return data;
   } catch (error) {
      throw error;
   }
};

export const getLotesCliente = async ({ rootState, dispatch, commit }) => {
   try {
      commit('poliza/setLotes', [], { root: true });
      const { data } = await httpInstance.post(`${urlFlujoAgro}/lotesCliente`, {
         id_cliente: rootState.poliza.poliza.id_cliente,
      });
      const lotes = data.map((lote) => {
         return {
            ...lote,
            cultivo: {
               id_cultivo: null,
               valor_referencial: null,
            },
         };
      });
      await Promise.all(
         lotes.map((lote) => dispatch('poliza/addLote', lote, { root: true })),
      );
      return lotes;
   } catch (error) {
      throw error;
   }
};
